import type { ActionFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import { z } from 'zod';
import { markConversationRead } from '~/modules/chat/api/mark-conversation-read.server';

export const MARK_CONVERSATION_READ_API =
    '/remix-api/chat/mark-conversation-read';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
    professionalID: z.coerce.number().int().positive().nullish(),
});

/**
 * API endpoint to mark a conversation as read for the current user. Use with the
 * `useConversation` hook.
 * @see {@link packages/web/app/modules/chat/context/ConversationContext.tsx}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return routerData(null, { status: 400 });
    }

    try {
        const response = await markConversationRead({
            context,
            conversationID: result.data.conversationID,
            professionalID: result.data.professionalID,
        });

        if (!response) {
            return routerData(null, { status: 500 });
        }

        return { conversation: response.conversation };
    } catch (error) {
        logger.error(`Error in ${MARK_CONVERSATION_READ_API}`, {
            error,
            data: result.data,
        });
        return routerData(null, { status: 500 });
    }
};
